var app = angular.module("leonardo");

var ReportsPropertyList = function ($scope, $controller, $filter, ReportService, FilterService) {

  $controller('ReportsBaseController', {$scope: $scope});

  $scope.title = $filter('translate')('Property Reports');
  $scope.report_type = ReportService.TYPE_PROPERTY;
  $scope.fieldsReport = ReportService.fieldsReportProperty;
  $scope.IdFields = ReportService.propertyIdFields;

  $scope.resetFields = function(){
    if (FilterService.hasFilter('extra_fields')) {
      $scope.extra_fields = FilterService.getFilter('extra_fields').split(',');
    }
    else {
      $scope.extra_fields = [];
    }

    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      $scope.fields_active = ReportService.defaultFieldsReportProperty;
    }
  };

  $scope.getFieldValue = function (report, field) {
    var html = '';
    switch (field) {
      case 'account':
      case 'portfolio':
        return report[field] ? report[field].name : '';
      case 'groups':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(element){
            html += '<span>' + element.name +'</span>';
          });
        }
        else {
          html = report[field] ? report[field].name : '';
        }
        return html;
      case 'managers':
        html = '';
        angular.forEach(report.managers, function (manager) {
          html += '<span>' + manager + '</span>';
        });
        return html;
      case 'property_managers':
        html = '';
        angular.forEach(report.property_managers, function (manager) {
          html += '<span>' + manager.first_name + ' ' + manager.last_name + '</span>';
        });
        return html;
      case 'last_activity':
        return report.last_activity ? report.last_activity.last_action : '';
      case 'managed_by':
        html = '';
        if (angular.isArray(report.managed_by)) {
          angular.forEach(report.managed_by, function(manager){
            html += '<span>' + manager.name +'</span>';
          });
        }
        else {
          html = report.managed_by ? report.managed_by.name : 'Only Owner';
        }
        return html;
      default:
        return report[field];
    }
  };

  $scope.groupReports = function(data) {
    if (data.results){
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.id) {
            id = value.id;
            name = value.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              if(FilterService.hasFilter('group_reports')){
                if(_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())){
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({id: group.id, name: group.name});
                }
              }else{
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({id: group.id, name: group.name});
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role;
            name = value.account_user.role;
            array_by_name = [{id: id, name: name}];
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, reports: []});
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.id) === -1) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, reports: []});
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.id) === -1) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }
    });

    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

};

app.controller('ReportsPropertyList', ['$scope', '$controller', '$filter', 'ReportService', 'FilterService',
  ReportsPropertyList]);
